<template lang="pug">
  v-row(no-gutters class="header-bottom" justify="space-between" align="center")
    router-link(to="/advert/list/rent") {{ $t('menu.link1') }}
    router-link(to="/advert/list/sale") {{ $t('menu.link2') }}
    router-link(to="/advert/list/commerce") {{ $t('menu.link4') }}
    // router-link(to="/advert/list/new") {{ $t('menu.link3') }}
    router-link(to="/complex/list") Новая недвижимость
    router-link(to="/advert/list/ik") {{ $t('menu.link5') }}
    router-link(to="/company/list") Строительные компании
</template>

<script>
export default {
  name: 'HeaderBottom'
}
</script>

<style scoped lang="scss">
.header {
  &-bottom {
    height: 36px;
    border-bottom: 1px solid #e0e0e0;
    a {
      position: relative;
      color: #292929;
      font-size: 14px;
      font-weight: 600;
      text-decoration: none;
      text-transform: capitalize;
      &:after {
        position: absolute;
        left: 0;
        bottom: -8px;
        width: 100%;
        height: 2px;
        background-color: #ff5964;
        content: '';
        opacity: 0;
        transition: opacity 0.3s;
      }
      &:hover {
        &:after {
          opacity: 1;
        }
      }
      &.router-link-active {
        &:after {
          opacity: 1;
        }
      }
    }
  }
}
</style>
